// extracted by mini-css-extract-plugin
export default {"detail":"Detail_detail__jBB-6","detail-checkbox-label":"Detail_detail-checkbox-label__89EYY"};